import type { SearchFilters, SearchResult } from "../types/filters";
import { api, projectScope } from "./client";

export const searchApi = {
  semantic(repoId: string, query: string, filters?: SearchFilters, projectId?: string): Promise<SearchResult[]> {
    return api.post<SearchResult[]>(
      projectScope(`/repos/${repoId}/search/semantic`, projectId),
      { query, ...filters }
    );
  },

  fulltext(repoId: string, query: string, filters?: SearchFilters, projectId?: string): Promise<SearchResult[]> {
    return api.post<SearchResult[]>(
      projectScope(`/repos/${repoId}/search/fulltext`, projectId),
      { query, ...filters }
    );
  },
};
